module.exports = __webpack_public_path__ + "static/media/emoji-agree.ee98a5c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/emoji-agree.svg
// module id = 453
// module chunks = 0